import React, { useState } from "react";
import { createUseStyles } from "react-jss";
import { retrieveTransfer } from "../../../../../../api/Vendor/Transfer";
import GenericBasicInfo from "../../../../../../components/cards/GenericBasicInfo";
import {
  cardStyles,
  modalGenericStyles,
  variables,
} from "../../../../../../variables";
import PropTypes from "prop-types";
import _ from "lodash";
import { genericRequestErrorHandler } from "../../../../../../api";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../../../../../components/Loader";
import { DateTime } from "luxon";
import VendorsDocuments from "../../../components/VendorsDocuments";
import ListPaymentTerms from "../../../components/paymentsTerms/ListPaymentTerms";
import TabStrip from "../../../../../../components/TabStrip";
import { CustomButton } from "../../../../../../components/CustomButton";
import VendorTRFConfigLogsTab from "./VendorTRFConfigLogsTab";
import DepositStatments from "../../../../CommonCRMModals/DepositStatmentss/DepositStatment";
import ProformaStatments from "../../../../CommonCRMModals/Proforma/List";
import { Price } from "../../../../../../components/Price";

const statusOptions = {
  "": "-----",
  AC: "Active",
  IN: "Inactive",
  CA: "Candidate",
};

const trueFalseMapping = {
  true: "Yes",
  false: "No",
};

const styles = createUseStyles({
  ...modalGenericStyles,
  DetailTransferModal: { ...modalGenericStyles.modal },
  modalCard: {
    ...modalGenericStyles.card,
    gridTemplateRows: "max-content max-content 1fr max-content",
  },
  modalCardHeader: {
    ...modalGenericStyles.cardHeader,
  },
  modalCardBody: {
    display: "grid",
    padding: variables.double_gap,
    minHeight: "30vh",
    maxHeight: "70vh",
    overflow: "auto",
  },
  modalCardActions: {
    ...modalGenericStyles.cardActions,
  },
  card: cardStyles.card,
  cardHeader: cardStyles.header,
  cardBody: {
    ...cardStyles.body,
    alignContent: "start",
    gap: variables.normal_gap,
  },
  row: {
    display: "grid",
    gridTemplateColumns: "repeat(1, 1fr)",
    gap: variables.normal_gap,
  },
  [`@media ${variables.media.smallscreen}`]: {
    cardBody: { justifyContent: "center" },
    row: {
      gridTemplateColumns: "1fr 1fr",
    },
  },
});

const DetailTransferModal = ({ id, onClose }) => {
  const classes = styles();

  const [activeTab, setActiveTab] = useState("basicData");

  const menuTabs = {
    basicData: "Basic Data",
    paymentTerms: "Payment Terms",
    proforma: "Proforma Statment",
    creditStatments: "Credit Statements",
    documents: "Documents",
    logs: "Logs",
  };

  const { data: transfer, isLoading: retrieveLoading } = useQuery({
    queryKey: ["DetailVendorTRF", id],
    queryFn: async () => await retrieveTransfer({ id: id }),
    onError: (error) => genericRequestErrorHandler(error),
  });

  const VendorDataCpl = [
    [
      "Vendor",
      null,
      _.get(transfer, "data.vendor", "").split("trf__")[1] || "N/A",
    ],
    [" Vendor Api Key", null, _.get(transfer, "data.vendor_data.apikey")],
    [" Vendor Secret", null, _.get(transfer, "data.vendor_data.secret")],
    [" Vendor Currency", null, _.get(transfer, "data.vendor_data.currency")],
  ];

  const basicDataCpl = [
    ["Id", "id"],
    ["Member", "member"],
    ["Market Type", "market_type"],
    [
      "Notify Amount",
      null,
      <Price
        currency={transfer?.data?.vendor_data?.currency}
        price={transfer?.data?.notify_amount}
      />,
    ],
    ["Config uid", null, _.get(transfer, "data.config_uid[0]", "") || "N/A"],
    ["Notes", "notes"],
    [
      "Payment Validation",
      null,
      _.get(trueFalseMapping, _.get(transfer, "data.payment_validation")),
    ],
    ["CXL Strategy Time", "cxl_strategy_time"],
    [
      "CXL Strategy Daysahead",
      null,
      _.get(transfer, "data.cxl_strategy_daysahead", []) === 0
        ? "0"
        : _.get(transfer, "data.cxl_strategy_daysahead"),
    ],
    [
      "Block Non Refundable",
      null,
      _.get(trueFalseMapping, _.get(transfer, "data.block_nonrefundable")),
    ],
    [
      "Status",
      null,
      _.get(statusOptions, _.get(transfer, "data.status", "") || "N/A"),
    ],
  ];

  const creatorData = [
    ["Creator", "creator"],
    [
      "Created",
      null,
      DateTime.fromISO(_.get(transfer, "data.created")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];
  const editorData = [
    ["Last Editor", "last_editor"],
    [
      "Edited",
      null,
      DateTime.fromISO(_.get(transfer, "data.edited")).toLocaleString(
        DateTime.DATE_MED_WITH_WEEKDAY
      ),
    ],
  ];

  const vendorContactData = [
    ["Title", "title"],
    ["First Name", "first_name"],
    ["Last Name", "last_name"],
    ["Email", "email"],
  ];
  return (
    <div id="DetailVendorTRFModal" className={classes.DetailTransferModal}>
      <div className={classes.modalCard}>
        <div className={classes.modalCardHeader}>
          <span>Transfer Detail</span>
        </div>
        <TabStrip
          tabs={Object.entries(menuTabs)}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <div className={classes.modalCardBody}>
          {retrieveLoading ? (
            <Loader />
          ) : (
            <React.Fragment>
              {activeTab === "basicData" && (
                <React.Fragment>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Basic Data"}
                        cardInfo={basicDataCpl}
                        objectData={_.get(transfer, "data", {})}
                      />
                    </div>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Creator Data"}
                        cardInfo={creatorData}
                        objectData={_.get(transfer, "data", {})}
                      />
                      <GenericBasicInfo
                        header={"Editor Data"}
                        cardInfo={editorData}
                        objectData={_.get(transfer, "data", {})}
                      />
                    </div>
                  </div>
                  <div className={classes.row}>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Vendor Data"}
                        cardInfo={VendorDataCpl}
                        objectData={_.get(transfer, "data.vendor_data", {})}
                      />
                    </div>
                    <div className={classes.cardBody}>
                      <GenericBasicInfo
                        header={"Vendor Contact Data"}
                        cardInfo={vendorContactData}
                        objectData={_.get(
                          transfer,
                          "data.vendor_data.contact_details",
                          {}
                        )}
                      />
                    </div>
                  </div>
                </React.Fragment>
              )}
              {activeTab === "paymentTerms" && (
                <ListPaymentTerms
                  showAddButton={true}
                  vendorId={_.get(transfer, "data.id")}
                />
              )}
              {activeTab === "proforma" && (
                <ProformaStatments
                  invalidationKey="DetailsSubAgentModal"
                  entityType="vendor"
                  entityData={_.get(transfer, "data", {})}
                />
              )}
              {activeTab === "creditStatments" && (
                <DepositStatments
                  invalidationKey="DetailVendorTRF"
                  entityType="vendor"
                  entityData={_.get(transfer, "data", {})}
                />
              )}
              {activeTab === "documents" && (
                <VendorsDocuments
                  queryKey={`vendor_transfer_document`}
                  tags={[`vendor__${_.get(transfer, "data.id")}`]}
                  entityData={_.get(transfer, "data", {})}
                />
              )}
              {activeTab === "logs" && <VendorTRFConfigLogsTab />}
            </React.Fragment>
          )}
        </div>
        <div className={classes.cardActions}>
          <CustomButton id="cancel" appearance="ghost" onClick={onClose}>
            <strong>Cancel</strong>
          </CustomButton>
        </div>
      </div>
    </div>
  );
};
DetailTransferModal.propTypes = {
  id: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};
export default DetailTransferModal;
